<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div *ngIf="EstCharge()">
    <p-card>
        <div class="flex align-items-center justify-content-between p-4">
            <div class="flex align-items-center gap-4">
                <i class="pi pi-shopping-bag text-primary text-2xl"></i>
                <div>
                    <div class="flex align-items-center gap-2">
                        <h3 class="m-0">{{ isNewVente ? 'Nouvelle vente' : 'Détail de la vente' }}</h3>
                        <span class="statut" [class]="vente.statut?.nom?.toLowerCase().replace(' ', '')">
                            {{ vente.statut?.nom }}
                        </span>
                    </div>
                    <p class="text-secondary m-0" *ngIf="!isNewVente && vente.numero">{{ vente.numero }}</p>
                </div>
            </div>
        </div>
        <app-menu-page-detail [model]="menu" [canEdit]="canEdit" [modeModification]="modeModification()" (onEdit)="Modifier()" (onSave)="sauvegarder($event)"
            (onCancel)="annuler()"></app-menu-page-detail>
    </p-card>

    <p-card styleClass="mt-4">
    <form #form [formGroup]="venteForm">
        <div class="fluid formgrid grid mx-0">
            <!-- Description -->
            <div class="sihc-field flex flex-column gap-2 my-2 col-12">
                <label for="description">
                    Description <span class="text-red-500">*</span>
                </label>
                <span *ngIf="!modeModification()" class="font-bold">{{ vente.description }}</span>
                <textarea *ngIf="modeModification()" id="description" pInputTextarea 
                    formControlName="description" [rows]="3" [maxlength]="500" class="w-full"
                    [class.ng-invalid]="venteForm.get('description')?.invalid && venteForm.get('description')?.touched">
                        </textarea>
                <small class="p-error block"
                    *ngIf="venteForm.get('description')?.invalid && venteForm.get('description')?.touched">
                    La description est requise (maximum 500 caractères).
                </small>
            </div>

            <!-- Client -->
            <div class=" sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
                <label for="client" class="">
                    Client <span class="text-red-500">*</span>
                </label>
                <span *ngIf="!modeModification()" class="font-bold">{{ vente.client }}</span>
                <p-autoComplete *ngIf="modeModification()"
                formControlName="client"
                    [suggestions]="clients"
                    (completeMethod)="filterClient($event)"
                    [disabled]="!canEdit"
                    class="w-full"
                    placeholder="Entrer le nom du client"
                    [class.ng-invalid]="venteForm.get('client')?.invalid && venteForm.get('client')?.touched"/>
                <small class="p-error block"
                    *ngIf="venteForm.get('client')?.invalid && venteForm.get('client')?.touched">
                    Veuillez sélectionner un client.
                </small>
            </div>

            <!-- Employé responsable -->
            <div class=" sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
                <label for="employe" class="">
                    Employé responsable <span class="text-red-500">*</span>
                </label>
                <span *ngIf="!modeModification()" class="font-bold"><app-employe-avec-emplacement *ngIf="vente.employe" [employe]="vente.employe"></app-employe-avec-emplacement><span *ngIf="!vente.employe">—</span></span>
                <p-dropdown *ngIf="modeModification()" id="employe" formControlName="employeId" [options]="employes" optionLabel="prenomNom"
                    optionValue="employeId" placeholder="Sélectionner un employé" [disabled]="!canEdit" [filter]="true"
                    filterBy="prenomNom" [showClear]="true" [virtualScroll]="true" [virtualScrollItemSize]="46"
                    class="w-full"
                    [class.ng-invalid]="venteForm.get('employeId')?.invalid && venteForm.get('employeId')?.touched">
                    <ng-template pTemplate="selectedItem" let-employe>
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-user"></i>
                            <span>{{ employe | nomEmploye | valeurVide }}</span>
                        </div>
                    </ng-template>
                    <ng-template let-employe pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-user"></i>
                            <span>{{ employe | nomEmploye | valeurVide }}</span>
                        </div>
                    </ng-template>
                </p-dropdown>
                <small class="p-error block"
                    *ngIf="venteForm.get('employeId')?.invalid && venteForm.get('employeId')?.touched">
                    Veuillez sélectionner un employé responsable.
                </small>
            </div>

            <!-- Date de livraison -->
            <div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
                <label for="dateLivraison">
                    Date de livraison
                </label>
                <span *ngIf="!modeModification()" class="font-bold">{{ vente.dateLivraison | date:'dd/MM/yyyy' }}</span>
                <p-calendar *ngIf="modeModification()" id="dateLivraison" formControlName="dateLivraison" [showIcon]="true"
                    dateFormat="yy-mm-dd" placeholder="Sélectionner une date" class="w-full">
                </p-calendar>
            </div>


            <div *ngIf="!isNewVente" class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
                <div class="flex align-items-center gap-2 mb-2">
                    <i class="pi pi-calendar text-primary"></i>
                    <span class="font-medium">Date de création:</span>
                </div>
                <span>{{ vente.dateCreation | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6" *ngIf="vente.creePar">
                <div class="flex align-items-center gap-2 mb-2">
                    <i class="pi pi-user text-primary"></i>
                    <span class="font-medium">Créé par:</span>
                </div>
                <app-employe-avec-emplacement *ngIf="vente.creePar" [employe]="vente.creePar"></app-employe-avec-emplacement><span *ngIf="!vente.creePar">—</span>
            </div>
        </div>

        <!-- Read-only message -->
        <div class="text-center pt-4" *ngIf="!canEdit">
            <p class="text-secondary">
                <i class="pi pi-info-circle"></i>
                Vous n'avez pas les permissions pour modifier cette vente.
            </p>
        </div>
    </form>
    </p-card>
</div>